module.exports = __webpack_public_path__ + "static/img/center_img3.b3e8ffda.png";